/*
 * Copyright 2023 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { Entity } from '@backstage/catalog-model';

import { createExtensionDataRef } from '@backstage/frontend-plugin-api';

/**
 * @internal
 * @deprecated TODO can be removed after https://github.com/backstage/backstage/pull/31128 is released
 */
export const entityFilterFunctionDataRef = createExtensionDataRef<
  (entity: Entity) => boolean
>().with({ id: 'catalog.entity-filter-function' });

/**
 * @internal
 * @deprecated TODO can be removed after https://github.com/backstage/backstage/pull/31128 is released
 */
export const entityLayoutOrderRef = createExtensionDataRef<number>().with({
  id: 'catalog.entity-layout.order',
});

/**
 * @internal
 * @deprecated TODO can be removed after https://github.com/backstage/backstage/pull/31128 is released
 */
export const entityFilterExpressionDataRef =
  createExtensionDataRef<string>().with({
    id: 'catalog.entity-filter-expression',
  });
